// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyRate_container__DDAW8"};